// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X3_ZQ","wrapperContent":"styles_wrapperContent__dRzqu"};